<template>
  <div class="mb-4">
    <div v-if="loading" class="text-center">
        <b-spinner label="Busy" class="m-5"></b-spinner>
    </div>
    <div v-else>
      <h4 id="profile-name" class="my-2">{{profile.name}} <b-button v-b-modal="'edit-profile-modal'" variant="secondary">Editar</b-button></h4>
      <b-modal id="edit-profile-modal"
        @ok="handleOk"
        @show="resetModal"
        @hidden="resetModal"
        title="Editar Perfil de Acesso"
        ok-title="Confirmar"
        cancel-title="Cancelar"
        >
          <b-form ref="formEditProfile" @submit.stop.prevent="handleSubmit">
            <b-form-group id="input-group-profile" :state="nameState" label="Nome do Perfil de Acesso:" label-for="input-profile"
              invalid-feedback="Nome do Perfil é necessário">
              <b-form-input id="input-profile" :state="nameState" v-model="profileName" required placeholder="Digite um Nome para o Perfil de Acesso"></b-form-input>
            </b-form-group>
          </b-form>
          <div v-if="modalLoading" class="text-center">
              <b-spinner label="Busy" class="m-1"></b-spinner>
          </div>
      </b-modal>
      <b-form-checkbox
                id="input-isAdmin"
                @change="swapAdmin()"
                :checked="profile.authorities.includes('ROLE_ADMIN')"
                class="my-2 mx-4"
              >Perfil de Administrador
      </b-form-checkbox>
      <b-button v-b-modal.modal-exluir variant="danger" class="my-2 mx-4">Excluir</b-button>
      <b-modal id="modal-exluir" @ok="remove"
        title="Confirma Exclusão?"
        ok-title="Excluir"
        ok-variant="danger"
        cancel-title="Cancelar"
        >
        <span>Deseja mesmo exluir o perfil de nome
          <br>"<b>{{profile.name}}</b>"?
          <br>Não será possível exluir caso exista algum usuário utilizando o perfil</span>
      </b-modal>

      <h4 id="profile-authorities" class="my-4">Permissões</h4>
      <div v-for="group in getGroups" :key="group.groupId" class="mb-4">
        <h4 for="group" class="text-left">
          <b-form-checkbox
            @change="checkAllReportsInGroup(group.groupId)"
            :checked="getReports.filter(
              report => report.groupId === group.groupId && report.hasPermission === false
            ).length === 0"
          >
            <strong>{{ group.name }}</strong>
          </b-form-checkbox>
        </h4>
        <div
          v-for="report in getReports.filter(
              report => report.groupId === group.groupId
            )"
          :key="report.reportId"
          class="ml-4"
        >
          <b-form-checkbox
            @change="swapPermission(report)"
            v-model="report.hasPermission"
          >{{ report.name }}</b-form-checkbox>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Profile",
  props: {
    profileId: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      profile: null,
      loading: true,
      profileName: "",
      nameState: null,
      modalLoading: false
    }
  },
  computed: {
    getGroups() {
      if(!this.profile){
        return [];
      }
      return this.$store.getters.getGroups;
    },
    getReports() {
      if(!this.profile){
        return [];
      }
      let reports = this.$store.getters.getReports;
      reports.forEach(report => {
        report.hasPermission = false;
        if (this.profile.authorities.includes(report.reportId)) {
          report.hasPermission = true;
        }
      });
      return reports;
    }
  },
  created() {
    this.loadProfile();
  },
  methods: {
    loadProfile(){
      this.$store.dispatch("retrieveProfile", this.profileId)
        .then(result => {
          this.profile = result.data;
          this.loading = false;
          this.profileName = this.profile.name;
        })
        .catch(error => {
          console.error(error);
          this.$store.dispatch("destroyToken");
          this.$router.push({ name: "login" });
        });
    },
    remove(){
      this.loading = true;
      this.$store.dispatch("deleteProfile", this.profileId)
        .then(() => {
          this.$store.dispatch("retrieveProfiles");
        })
        .catch(error => {
          console.error(error);
          this.makeToast('danger', "Não foi possível remover o perfil, verifique se ele está em uso por algum usuário.");
          this.loading = false;
        })
    },
    swapPermission(report) {
      if (report.hasPermission) {
        this.$store.dispatch("removeAuthority", {
          reportId: report.reportId,
          profileId: this.profile.id
        })
        .then(() => {
          this.profile.authorities.splice(this.profile.authorities.indexOf(report.reportId), 1);
        })
        .catch(error => {
          console.error(error);
          this.makeToast('danger', "Não foi possível alterar a permissão");
        });
      } else {
        this.$store.dispatch("addAuthority", {
          reportId: report.reportId,
          profileId: this.profile.id
        })
        .then(() => {
          this.profile.authorities.push(report.reportId);
        })
        .catch(error => {
          console.error(error);
          this.makeToast('danger', "Não foi possível alterar a permissão");
        });
      }
    },
    checkAllReportsInGroup(selectedGroupId) {
      this.getReports
        .filter(
          report =>
            report.groupId === selectedGroupId &&
            report.hasPermission === !event.target.checked
        )
        .forEach(report => this.swapPermission(report));
    },
    makeToast(variant = null, content) {
      this.$bvToast.toast(content, {
        title: 'Aviso',
        variant: variant,
        solid: true
      })
    },
    swapAdmin(){
      if(!event.target.checked){
        this.$store.dispatch("removeAuthority",
        {
          reportId: "ROLE_ADMIN",
          profileId: this.profile.id
        });
      } else {
        this.$store.dispatch("addAuthority",
        {
          reportId: "ROLE_ADMIN",
          profileId: this.profile.id
        });
      }
    },
    resetModal() {
      this.profileName = this.profile.name;
      this.nameState = null;
      this.modalLoading = false;
    },
    handleOk(bvModalEvt) {
      // Prevent modal from closing
      bvModalEvt.preventDefault()
      // Trigger submit handler
      this.handleSubmit()
    },
    handleSubmit() {
      // Exit when the form isn't valid
      if (!this.checkFormValidity()) {
        return
      }
      // Hide the modal manually
      var hideModal = () => {
        this.$nextTick(() => {
          this.$bvModal.hide('edit-profile-modal')
        });
      }
      // Create the new Profile
      this.editProfile(hideModal);
    },
    checkFormValidity() {
      const valid = this.$refs.formEditProfile.checkValidity()
      this.nameState = valid;
      return valid
    },
    editProfile(callback){
      this.modalLoading = true;
      // Create the new Profile
      this.$store.dispatch("editProfile", {profileName: this.profileName, profileId: this.profile.id})
      .then(() => {
        // Update profiles
        this.$store.dispatch("retrieveProfiles")
          .then(() => {
            callback();
            this.loadProfile();
            // This horrible thing was done to try to select the new profile in the list after DOM reload
            // this.$nexttick was not enough
            // setTimeout(() =>{
            //   this.selectedProfile = this.getProfiles.findIndex(element => {
            //     return element.id === profileResponse.data.id;
            //   }, 900);
            // });
          });
      })
      .catch(error => {
          console.error(error);
          this.$store.dispatch("destroyToken");
          this.$router.push({ name: "login" });
      });
    },
  }
};
</script>

<style scoped>
#profile-name {
  text-align: left;
}
#profile-authorities {
  text-align: left;
}
</style>
